import Vue from 'vue'
import initialState from '@/store/initial-state'

function toggleShowOnlyProducers(state) {
  state.cubeFilter.showOnlyProducers = !state.cubeFilter.showOnlyProducers
}

function toggleShowOnlyProducersWithCapacity(state) {
  state.cubeFilter.showOnlyProducersWithCapacity = !state.cubeFilter
    .showOnlyProducersWithCapacity
}

function setEnergyType(state, energyType) {
  state.cubeFilter.energyType = energyType
}

function setPriceMin(state, priceMin) {
  state.cubeFilter.priceMin = priceMin
}

function setPriceMax(state, priceMax) {
  state.cubeFilter.priceMax = priceMax
}

function resetFilter(state) {
  Vue.set(state, 'cubeFilter', initialState().cubeFilter)
}

export default {
  toggleShowOnlyProducers,
  toggleShowOnlyProducersWithCapacity,
  setEnergyType,
  setPriceMin,
  setPriceMax,
  resetFilter,
}
